import MButton from '@assets/mui/@material-extend/MButton';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';
import AlertMUI, { AlertColor } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import RoutesSerchResultAlertContainer from './StyledComponents';

interface AlertProps {
  color: AlertColor;
  title?: React.ReactNode;
  text: React.ReactNode;
  detailsText: React.ReactNode;
}

function Alert({ color, text, title, detailsText }: AlertProps) {
  const [isFullView, setFullView] = useState<boolean>(false);

  const { t } = useTranslation(['RoutesListComponent']);

  return (
    <RoutesSerchResultAlertContainer>
      <AlertMUI color={color} severity={color}>
        {!!title && <AlertTitle>{title}</AlertTitle>}
        {text}
        <MButton
          onClick={() => setFullView((state) => !state)}
          variant={'outlined'}
          className={'switch'}
          color={color}
          fullWidth={true}
        >
          <span>{t('RoutesListComponent:routesList.DetailsButton')}</span>
          {isFullView && <KeyboardArrowUpRoundedIcon sx={{ fontSize: '20px', color: '#383838' }} />}
          {!isFullView && (
            <KeyboardArrowDownRoundedIcon sx={{ fontSize: '20px', color: '#383838' }} />
          )}
        </MButton>
        {isFullView && <div className="details-wrap">{detailsText}</div>}
      </AlertMUI>
    </RoutesSerchResultAlertContainer>
  );
}

export { Alert };
